var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('header',[_c('Header',{attrs:{"msg":"Header"}}),_c('SettingsHeader',{attrs:{"msg":"SettingsHeader"}})],1),_c('QCMoney',{attrs:{"msg":"QCMoney"}}),_c('Footer',{attrs:{"msg":"Footer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }